import React from "react";
import PropTypes from "prop-types";
import moment from 'moment';
import * as zoom from 'chartjs-plugin-zoom';

import Chart from "../../utils/chart";
const axios = require('axios').default;



class TopicGraph extends React.Component {
    constructor(props) {
        super(props);
        this.minLength = -this.minLength; //-(14 * 24 * 4)--> //14 days
        this.fullChartData = null;
        this.chartData = null;
        this.chartStart = this.minLength;
        this.chartEnd = -1;
        this.maxCnt = 1000;
        this.tweetData = null;
        this.dataAll = null;
        this.canvasRef = React.createRef();
        this.labelstart = this.labelstart1;
        // this.labelend  = myDate.getTime();
        // console.log("111" + this.labelend1);

    }

    componentDidMount() {
        this.intializeChart();
    }

    intializeChart = () => {
        axios.get(`data/topic${this.props.topicId}.json`) // data/topicsData1.json
            .then(response => {
                this.chartData = { ...response.data.chartData };
                this.fullChartData = { ...response.data.chartData };
                this.tweetData = response.data.chartData.datasets[0].data;
                this.dataAll = response.data.chartData.labels;
                // console.log(this.chartData);
                // console.log(new Date(this.chartData.labels[0]).getTime());

                this.buildChart();
                this.updateChartData();
                this.chart.update();
                this.timelabel = response.data.chartData.labels;
                // this.labelstart1 = {...new Date(this.timelabel[0]).getTime()};
                // this.labelend1 = {...new Date(this.timelabel[this.timelabel.length-1]).getTime()};
                
                
                
            })

       
    }

    buildChart = (Y_max) => {
        const chartOptions = {
            ...{
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                elements: {
                    line: {
                        // A higher value makes the line look skewed at this ratio.
                        tension: 0.3
                    },
                    point: {
                        radius: 0
                    }
                },
                scales: {
                    xAxes: [

                        {
                            type: 'time',
                            scaleLabel: {
                                display: true,
                                labelString: 'Time (UTC)',
                                fontColor: '#f4f4f4',
                            },
                            time: {
                                displayFormats: {
                                    hour: 'MMM D hA'
                                },
                                unit: 'day',
                                unitStepSize: 1
                            },
                            ticks: {
                                display: true,
                                fontColor: '#f4f4f4',
                                
                            },
                            gridLines: {
                                color: 'rgba(0, 0, 0, 0.1)',
                            }

                        }
                    ],

                    yAxes: [
                        {
                            ticks: {
                                display: true,
                                min: 0,
                                // stepSize: 1
                                precision: 0,
                                fontColor: '#f4f4f4',
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Tweets per 15 min',
                                fontColor: '#f4f4f4',
                                
                            }

                        }
                    ]
                },
                hover: {
                    mode: "nearest",
                    intersect: false,
                },
                tooltips: {
                    custom: false,
                    mode: "nearest",
                    intersect: false
                },
                plugins: {
                    // colorschemes: {

                    //     scheme: 'brewer.YlGn3'
                
                    //   },
                    zoom: {
                        pan: {
                            enabled: true,
        
                            mode: 'x',
                            rangeMin: {
                                x: new Date(this.chartData.labels[0]).getTime(),
                                y: 0
                            },
                            rangeMax: {
                                x: new Date(this.chartData.labels[this.chartData.labels.length-1]).getTime(),
                                y: null
                            },
                            speed: 20,

                            threshold: 10,

                        
                        },

                        zoom: {
                            
                            enabled: true,
        
                            mode: 'x',
                            speed: 0.1,
                            rangeMin: {
                                x: new Date(this.chartData.labels[0]).getTime(),
                                y: 0
                            },
                            rangeMax: {
                                x: new Date(this.chartData.labels[this.chartData.labels.length-1]).getTime(),
                                y: null
                            },

                            threshold: 2,

                            sensitivity: 3,
		
                        }
                    }
                }
            },
            ...this.props.chartOptions
        };

        this.chart = new Chart(this.canvasRef.current, {
            type: "LineWithLine",
            data: this.chartData,
            options: chartOptions,
            
            
        });

        // They can still be triggered on hover.
        const buoMeta = this.chart.getDatasetMeta(0);
        buoMeta.data[0]._model.radius = 0;
        buoMeta.data[
            this.chartData.datasets[0].data.length - 1
            
        ]._model.radius = 0;

        // Render the chart.
        this.chart.render();

    }

    updateChartData = () => {
        this.chartData.datasets[0].data = this.tweetData.slice(this.chartStart, this.chartEnd)
        this.chartData.labels = this.fullChartData.labels.slice(this.chartStart, this.chartEnd);
    }

    resetChart = () => {
        this.chartStart = -this.minLength;
        this.chartEnd = -1;
        this.updateChartData();
        this.chart.update();
    }

    


    render() {
        return (
            <div style={{height: "250px"}}>
                <canvas
                    height="70"
                  
                    ref={this.canvasRef}
                    style={{ maxWidth: "100% !important" }}
                />
            </div>
        );
    }
}

TopicGraph.propTypes = {
    /**
     * The component's title.
     */
    title: PropTypes.string,
    /**
     * The chart dataset.
     */
    chartData: PropTypes.object,
    /**
     * The Chart.js options.
     */
    chartOptions: PropTypes.object
};

TopicGraph.defaultProps = {
    title: "Popular Fake News on Twitter",
};

export default TopicGraph;
